<template>
  <div>
    <v-card class="mx-auto" width="90%" min-height="100%" color="white">
      <v-card-text class="pa-2">
        <p class="mb-2 third--text font-weight-bold">Libellé: {{ sessionsDetail.name }}</p>
        <p class="mb-2">Horaire de la session: {{ sessionsDetail.time }}</p>
        <p class="mb-2 third--text font-weight-bold">Moniteur: {{ sessionsDetail.instructors }}</p>
        <p class="mb-2">Lieu de pratique: {{ sessionsDetail.place }}</p>
        <p class="mb-0 third--text font-weight-bold">Discipline: {{ sessionsDetail.discipline }}</p>
      </v-card-text>
      <v-divider />
      <v-card-text ref="scrollableContentTypeList" class="py-0 pt-2 px-0">
        <v-row no-gutters class="text-center third white--text">
          <v-col cols="6">
            CAVALIERS
          </v-col>
          <v-col cols="6">
            EQUIDES
          </v-col>
        </v-row>
        <v-row no-gutters class="overflow-y-hidden" style="max-height: 570px;">
          <ul :class="[{'scrollableList': showAnimation}, 'full-width']">
            <li v-for="(participantHorse, index) in sessionsDetail.participantHorseList" :key="`display_participant_horse_${index}`" style="border-bottom: 1px solid #000;">
              <v-row no-gutters class="text-center">
                <v-col cols="5">
                  <p v-if="participantHorse.participant" class="mb-2 font-weight-bold">{{ participantHorse.participant.firstname }} {{ participantHorse.participant.lastname.slice(0, 3) }}</p>
                  <v-icon v-else color="third">mdi-close</v-icon>
                </v-col>
                <v-col cols="2">
                  <v-icon
                    color="black"
                  >
                    mdi-code-tags
                  </v-icon>
                </v-col>
                <v-col cols="5">
                  <p v-if="participantHorse.horse" class="mb-2 font-weight-bold">{{ participantHorse.horse.horse_name }}</p>
                  <v-icon v-else color="third">mdi-close</v-icon>
                </v-col>
              </v-row>
            </li>
          </ul>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api';
import { format } from 'date-fns';
import store from '@/store';
import { isObjectEmpty } from '@/helpers/utils';

export default {
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    const scrollableContentTypeList = ref(null);
    const session = ref(props.session);
    const disciplines = computed(() => store.state.disciplines);

    const sessionsDetail = computed(() => {
      let instructor = null;
      let place = null;
      let discipline = null;

      if (props.session.instructors && props.session.instructors.length) {
        instructor = props.session.instructors.map(i => store.getters.instructor(i.uuid)).map(i => (i ? i.firstname : '')).join(', ');
      }

      if (props.session.place && !isObjectEmpty(props.session.place)) {
        place = store.getters.place(props.session.place.uuid);
      }

      const participantHorseList = [];

      (props.session.participants || []).map(p => {
        const pair = { participant: p, horse: null };
        if (p.horse) {
          pair.horse = store.getters.horse(p.horse);
        }
        participantHorseList.push(pair);
      });

      (props.session.horses || []).map(horse => {
        const horses = participantHorseList.filter(participantHorse => participantHorse.horse && participantHorse.horse.uuid);
        if (horses.every(participantHorse => participantHorse.horse.uuid !== horse.uuid)) {
          participantHorseList.push({ participant: null, horse: store.getters.horse(horse.uuid) });
        }
      });

      if (props.session.discipline) {
        const sessionDiscipline = disciplines.value.find(d => d.uuid === props.session.discipline.uuid);

        if (sessionDiscipline) {
          discipline = sessionDiscipline.name;
        }
      }

      return {
        name: props.session.name,
        time: `de ${format(new Date(props.session.start_time * 1000), "HH'h'mm")} à ${format(new Date(props.session.end_time * 1000), "HH'h'mm")}`,
        instructors: instructor,
        place: place ? place.place_name : null,
        participantHorseList,
        discipline: discipline
      };
    });

    const showAnimation = computed(() => {
      if (scrollableContentTypeList.value) {
        return scrollableContentTypeList.value.clientHeight >= 590;
      }
      return false;
    });

    watch(() => props.session, () => {
      session.value = props.session;
    });
    return { sessionsDetail, scrollableContentTypeList, showAnimation };
  }
};
</script>

<style>
  @keyframes slideY {
    from {
      transform: translateY(0%);
    }
    to {
      transform: translateY(calc(-100% + 570px));
    }
  }
  @-webkit-keyframes slideY {
    from {
      transform: translateY(0%);
    }
    to {
      transform: translateY(calc(-100% + 570px));
    }
  }
  @-moz-keyframes slideY {
    from {
      transform: translateY(0%);
    }
    to {
      transform: translateY(calc(-100% + 570px));
    }
  }
  .scrollableList{
    animation: slideY 20s ease-in-out 2s infinite alternate;
    -webkit-animation: slideY 20s ease-in-out 2s infinite alternate;
    -moz-animation: slideY 20s ease-in-out 2s infinite alternate;
  }
</style>
